import { Routes, Route } from "react-router-dom";
import "./App.css";

import HomeChoice             from "./HomeChoice";        // NEW — landing page
import CertificatePortal      from "./Certificateportal";
import MyCertificate          from "./MyCertificate";     // NEW — re-download
import DownloadPage           from "./Downloadpage";
import CertificatePage        from "./CertificatePage";
import VerifyCertificate      from "./VerifyCertificate";
import AdminPanel             from "./Adminpanel";
import WebinarCertificate     from "./WebinarCertificate";
import WebinarVerify          from "./WebinarVerify";
import WebinarCertificatePage from "./WebinarCertificatePage";
import ModuleAdminPanel       from "./ModuleAdminPanel";

function App() {
  return (
    <Routes>
      {/* ── Landing — student chooses their path ── */}
      <Route path="/" element={<HomeChoice />} />

      {/* ── First time: request form ── */}
      <Route path="/request" element={<CertificatePortal />} />

      {/* ── Re-download: enter email, get certificate ── */}
      <Route path="/my-certificate" element={<MyCertificate />} />

      {/* ── Download / render ── */}
      <Route path="/download"    element={<DownloadPage />} />
      <Route path="/certificate" element={<CertificatePage />} />

      {/* ── Verify (QR code lands here) ── */}
      <Route path="/verify/:verifyId"         element={<VerifyCertificate />} />
      <Route path="/webinar-verify/:verifyId" element={<WebinarVerify />} />

      {/* ── Webinar ── */}
      <Route path="/webinar"             element={<WebinarCertificate />} />
      <Route path="/webinar-certificate" element={<WebinarCertificatePage />} />

      {/* ── Admin ── */}
      <Route path="/admin"        element={<AdminPanel />} />
      <Route path="/webinarAdmin" element={<ModuleAdminPanel />} />

      {/* ── 404 ── */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function NotFound() {
  return (
    <div style={{
      minHeight: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center", gap: 14,
      fontFamily: "'Segoe UI', system-ui, sans-serif",
      background: "#f0f4ff", padding: 24, textAlign: "center",
    }}>
      <div style={{ fontSize: 56 }}>🔍</div>
      <h1 style={{ color: "#1e1b4b", fontSize: 24, margin: 0 }}>Page Not Found</h1>
      <p style={{ color: "#64748b", fontSize: 15, margin: 0 }}>
        The page you are looking for does not exist.
      </p>
      <a href="/" style={{
        background: "#ff5421", color: "#fff", padding: "12px 26px",
        borderRadius: 10, textDecoration: "none", fontWeight: 700,
        fontSize: 15, marginTop: 6,
      }}>
        🏠 Go to Home
      </a>
    </div>
  );
}

export default App;